<template>
    <div class="more-items-card h-full" :class="variantClass">
        <div class="more-items__count">+{{ itemsLeftCount }}</div>
        <div class="more-items__label">
            {{ itemsLeftLabel }}
        </div>
        <div>
            <CButton
                :to="route ? route : undefined"
                :variant="buttonVariant"
                @click="route ? undefined : emit('click-button', $event)"
            >
                {{ buttonText }}
            </CButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import { computed } from 'vue'

interface Props {
    variant?: string
    route?: Record<string, any>
    itemsLeftLabel: string
    itemsLeftCount: number
    buttonText: string
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'default',
    route: undefined
})

const variantClass = computed(() => {
    if (props.variant === 'primary') return 'bg-primary-500'
    // Section color of Dobrovoľníctvo (see the nav bar); light, so it needs dark text
    if (props.variant === 'volunteering') return 'bg-[#eab308] text-gray-900'
    return 'bg-white dark:bg-surface-card'
})

const buttonVariant = computed(() => {
    if (props.variant === 'primary') return 'white'
    if (props.variant === 'volunteering') return 'gray-750'
    return 'default'
})

const emit = defineEmits(['click-button'])
</script>

